<template>
  <TabbedBox>
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-1">
        <i class="far fa-envelope-open-dollar"></i> Invoices
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-1">

        <InvoiceDataTable>
          <template v-slot:title>
            <h3>Invoice List</h3>
          </template>
          <template v-slot:tools>
            
          </template>
        </InvoiceDataTable>

      </TabPage>
    </template>
  </TabbedBox>
</template>

<script>
import InvoiceDataTable from '@/modules/accounts/components/invoiceDataTable'

export default {
  name: 'InvoiceList',
  components: {
    InvoiceDataTable
  },
  props: {
    filterType: String
  },
  computed: {
    title() {
      return this.$route.meta.title
    }
  },
  methods: {
  }
};
</script>
